import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border h-full p-8 shadow p-4 rounded-3" }
const _hoisted_2 = ["href"]

import WelcomeItem from "./WelcomeItem.vue";
import DocumentationIcon from "./icons/IconDocumentation.vue";
import EcosystemIcon from "./icons/IconEcosystem.vue";
import CommunityIcon from "./icons/IconCommunity.vue";
import { RouterLink } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'TheWelcome',
  setup(__props) {

const mailing_list = `${process.env.VUE_APP_MAILING_LIST_EMAIL}`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _cache[1] || (_cache[1] = _createTextVNode(" PICNIC (Proteins Involved in CoNdensates In Cells) is machine learning-based model that predicts proteins involved in biomolecular condensates. The first model (PICNIC) is based on sequence-based features and structure-based features derived from Alphafold2 models. Another model includes extended set of features based on Gene Ontology terms (PICNIC-GO). Although this model is biased by the already available annotations on proteins, it provides useful insights about specific protein properties that are enriched in proteins of biomolecular condensate. Overall, we recommend using PICNIC that is an unbiased predictor, and using PICNIC-GO for specific cases, for example for experimental hypothesis generation. ", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _createVNode(_unref(RouterLink), {
        class: "btn btn-sm btn-primary mt-2",
        to: "/about-us"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Read more", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(WelcomeItem, null, {
      icon: _withCtx(() => [
        _createVNode(DocumentationIcon)
      ]),
      heading: _withCtx(() => [...(_cache[3] || (_cache[3] = [
        _createTextVNode("Documentation", -1)
      ]))]),
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createTextVNode(" PICNIC's source code is available in ", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("a", {
          href: "https://git.mpi-cbg.de/tothpetroczylab/picnic",
          target: "_blank",
          rel: "noopener"
        }, "Gitlab repository", -1)),
        _cache[6] || (_cache[6] = _createTextVNode(" and the publication can be found ", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("a", {
          href: "https://doi.org/10.1038/s41467-024-55089-x",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "here", -1)),
        _cache[8] || (_cache[8] = _createTextVNode(". ", -1))
      ]),
      _: 1
    }),
    _createVNode(WelcomeItem, null, {
      icon: _withCtx(() => [
        _createVNode(EcosystemIcon)
      ]),
      heading: _withCtx(() => [...(_cache[9] || (_cache[9] = [
        _createTextVNode("Condensate ecosystem", -1)
      ]))]),
      default: _withCtx(() => [
        _cache[10] || (_cache[10] = _createTextVNode(" We strongly support the condensate ecosystem: ", -1)),
        _cache[11] || (_cache[11] = _createElementVNode("a", {
          href: "https://cd-code.org/",
          target: "_blank",
          rel: "noopener"
        }, "CD-CODE", -1)),
        _cache[12] || (_cache[12] = _createTextVNode(", ", -1)),
        _cache[13] || (_cache[13] = _createElementVNode("a", {
          href: "https://dresdencondensates.org/",
          target: "_blank",
          rel: "noopener"
        }, "Dresden Condensates", -1)),
        _cache[14] || (_cache[14] = _createTextVNode(". ", -1))
      ]),
      _: 1
    }),
    _createVNode(WelcomeItem, null, {
      icon: _withCtx(() => [
        _createVNode(CommunityIcon)
      ]),
      heading: _withCtx(() => [...(_cache[15] || (_cache[15] = [
        _createTextVNode("Contact us", -1)
      ]))]),
      default: _withCtx(() => [
        _cache[16] || (_cache[16] = _createTextVNode(" Any question? Please get in touch ", -1)),
        _createElementVNode("a", {
          href: 'mailto:' + mailing_list
        }, _toDisplayString(mailing_list), 8, _hoisted_2),
        _cache[17] || (_cache[17] = _createTextVNode(". ", -1))
      ]),
      _: 1
    })
  ], 64))
}
}

})